// Open modal
jQuery(document).ready(function() {
  jQuery('.open-emergency-modal').on('click', function() {
    id = 'emergencyModal';

    jQuery('.modal#' + id).show();
    document.body.classList.add('modal-open');
  });

  jQuery( '.open-modal' ).on( 'click', function() {

    var id = jQuery( this ).attr( 'modal-id' );

    if (!id) {
      id = 'quoteModal';
    }

    jQuery( '.modal#' + id ).show();

    document.body.classList.add('modal-open');
  } );
});




// Close modal on x click
jQuery(document).ready(function() {
  jQuery( '.modal-close' ).on( 'click', function() {
    var id = jQuery( this ).closest( '.modal' ).attr( 'id' );

    jQuery( '#' + id ).hide();

    document.body.classList.remove('modal-open');
  } );
});

jQuery( '.modal .modal-content #modalSlider' ).slick( {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  rows: 0,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  prevArrow: jQuery( '.modal .modal-content .arrows .prev' ),
  nextArrow: jQuery( '.modal .modal-content .arrows .next' ),
} );

// On page load if hash exists and it matches modal ID, open the modal
jQuery(document).ready(function() {
  var hash = window.location.hash.substring(1);
  
  if (hash) {
    var pageModal = jQuery( '.modal#' + hash );

    if (pageModal.length) {
      var id = pageModal.attr( 'id' );
      jQuery( '#' + id ).show();
  
      document.body.classList.add('modal-open');
    }
  }
});